import { useMemo } from 'react';
import { useEditorStore } from '~/shell/Store';

export const useConversationBotId = (
  id: string,
  fallbackConversationBotId?: number | string
) => {
  const { sequence } = useEditorStore();

  const conversationBotId = useMemo(() => {
    const currentItem = sequence?.items?.find(
      (item: any) =>
        (item.__typename === 'ChatBot' || item.typename === 'ChatBot') &&
        item.id === id
    ) as any;

    return currentItem?.conversationBotId ?? fallbackConversationBotId;
  }, [sequence?.items, id, fallbackConversationBotId]);

  const hasCreatedBots = useMemo(
    () => conversationBotId !== undefined && conversationBotId !== null,
    [conversationBotId]
  );

  return {
    conversationBotId,
    hasCreatedBots
  };
};
